import { useEffect, useState } from 'react';
import { getDesignPresets } from '../api/presetApi';

// Text styles are resolved per box; a page has no active preset assignment.
export function usePageTextStyles() {
  const [designPresets, setDesignPresets] = useState([]);
  const [bookDefaultPresetId, setBookDefaultPresetId] = useState(undefined);
  useEffect(() => {
    let cancelled = false;
    getDesignPresets().then((response) => {
      if (!cancelled) setDesignPresets(response.data);
    }).catch((error) => console.error('Failed to load text styles', error));
    return () => { cancelled = true; };
  }, []);
  return { designPresets, bookDefaultPresetId, setBookDefaultPresetId,
    mainTextDisplayMode: 'both' };
}
